module.exports = __webpack_public_path__ + "static/media/ZEFI-BNB.65c2dd1c.svg";